import { IEventNotifier, TranscriptionNotifyEvent } from "../../interfaces/IEventNotifier";
import { HostAppSettingName, HostAppSettings } from "../../office-js/HostAppSettings";

//EventManager class will handle all the notify events from transcription and will allow every registered notifier to notify the events.
export class EventManager {

  private static instance : EventManager;

  static GetInstance() {
    if (this.instance == null) this.instance = new EventManager();

    return this.instance;
  }

  // eventListenerSet will keep registered event listeners.
  private eventNotifierSet = new Set<IEventNotifier>();

  static IsNotifyTranscriptionEventToHostAppEnabled() : boolean {
    return HostAppSettings.IsSettingTrue(HostAppSettingName.NotifyTranscriptionEventToHostAppEnabled);
  }

  HandleEvent(eventName : TranscriptionNotifyEvent, payload?: any) {
    if (this.eventNotifierSet.size != 0) {
      this.eventNotifierSet.forEach(function (eventListener) {
        eventListener.SendEvent(eventName, payload);
      });
    }
  }

  RegisterEventNotifier(eventNotifier : IEventNotifier) : void {
    this.eventNotifierSet.add(eventNotifier);
  }

  UnregisterEventNotifier(eventNotifier : IEventNotifier) : void {
    this.eventNotifierSet.delete(eventNotifier);
  }
}